import { ErrorIdentifier } from './error-identifier';

export const reportNotFoundErrorIdentifier: ErrorIdentifier = (_: number, error: any) => {
  if (error.message.indexOf('Report not found') > -1) {
    return false;
  }

  return null;
};
